<template>
  <el-container>
    <!-- 侧边栏 -->
    <!-- <el-aside :width="isCollapse ? '64px' : '240px'"> -->
    <el-aside :width="asideWidth">
      <el-menu
        :default-active=path
        class="el-menu-vertical-demo"
        background-color="#00264a"
        text-color="#fff"
        active-text-color="#ffd04b"
        unique-opened
        :collapse="isCollapse"
        :collapse-transition="false"
        router
      >
        <div class="logo">
          <img src="../assets/whitelogo.png" alt="" :style="isCollapse ? 'width:32px;height:32px;margin-top:2px;vertical-align:-11px;border-radius:12px;margin-left:-4px':'width:32px;height:32px;margin-top:2px;vertical-align:-9px;border-radius:12px;margin-left:-4px'">
          <h1 v-show="isShow">{{title}}</h1>
        </div>
        <template v-for="item in menuList">
          <el-submenu v-if="item.children.length > 0" :index=item.path :key="item.path" >
            <template slot="title">
              <i :class="iconObj[item.id]"></i>
              <span>{{item.authName}}</span>
            </template>
            <el-menu-item :index=subItem.path v-for="subItem in item.children" :key="subItem.id" @click="saveNavState(subItem.path)">
              <i :class="iconObj[subItem.id]"></i>
              <span slot="title">{{subItem.authName}}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :index=item.path :key="item.path" @click="saveNavState(item.path)">
            <a v-if="item.authName === '接入文档'" href="http://docs.7ccccccc.com" target="_blank">
              <i :class="iconObj[item.id]"></i>
              <span slot="title">{{item.authName}}</span>
            </a>
            <div v-else>
              <i :class="iconObj[item.id]"></i>
              <span slot="title">{{item.authName}}</span>
            </div>
          </el-menu-item>
        </template>
        
      </el-menu>

      
    </el-aside>
    <!-- 页面主体 -->
    <el-container>
      <!-- 头部 -->
      <el-header>
        <!-- 左侧图标 -->
        <i :class="isCollapse ?'el-icon-s-unfold':'el-icon-s-fold'" @click="foldCollapse"></i>
        <!-- 退出登录按钮 -->
        <div class="head-right">
          <!-- <el-button class="logout" size="small" type="info" @click="logout" plain>退出登录</el-button> -->
          <el-button class="icon-copy el-icon-share" size="small" v-clipboard:copy="shareLink" v-clipboard:success="onCopyLink"><i style="margin-top:1px"></i><span>点击复制邀请链接</span></el-button>
          <el-dropdown size="medium">
            <!-- <div class="avatar" ref="avatarRef"> -->
              <!-- <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar> -->
              <span ref="emailwidh" >{{email}}</span>
            <!-- </div> -->
            <el-dropdown-menu slot="dropdown" :style="{marginTop:'-3px', width:dropdownWidth+'px'}">
              <el-dropdown-item @click.native="logout" style="vertical-align: middle;"><i :class="'iconfont icon-tuichu'"></i>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
        
      <!-- 右侧主体 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      //左侧菜单数据
      menuList:[],
      iconObj:{
        '125':'iconfont icon-xiaolian',
        '126':'iconfont icon-shujudaping',
        '127':'iconfont icon-xiangmuguanli',
        '128':'iconfont icon-qiamizhifu',
        '129':'iconfont icon-duoyonghu',
        '130':'iconfont icon-duoyonghu',
        '131':'iconfont icon-jilu-copy-copy',
        '132':'iconfont icon-yuancheng-o',
        '133':'iconfont icon-bianliang',
        '134':'iconfont icon-yuanchengshuju',
        '135':'iconfont icon-hanshu',
        '136':'iconfont icon-dai',
        '137':'iconfont icon-duoyonghu',
        '138':'iconfont icon-jilu-copy-copy',
        '139':'iconfont icon-jifenjilu',
        '140':'iconfont icon-bug',
        '141':'iconfont icon-zhaoshangdailifenlei',
        '142':'iconfont icon-jieru',

        '143':'iconfont icon-xiaolian',
        '144':'iconfont icon-xiangmuguanli',
        '145':'iconfont icon-qiamizhifu',
        '146':'iconfont icon-jilu-copy-copy',
        '147':'iconfont icon-jifenjilu',
        '148':'iconfont icon-zhaoshangdailifenlei',
        '149':'iconfont icon-chongzhi01',
        '150':'iconfont icon-zhaoxueyuan',
        // '151':'iconfont icon-chongzhi01',
        '152':'iconfont icon-yunxiazai4'
      },
      isCollapse:false,
      path: this.$store.state.path,
      role: "",
      isShow: true,
      title: "",
      asideWidth:"",
      screenWidth: document.body.clientWidth,
      shareLink: `http://developer.7ccccccc.com/register?ref=${window.sessionStorage.getItem('shareId')}`,
      email:"",
      dropdownWidth:""
    };
  },
  watch:{
    // isCollapse(val, oldVal){
    //   if(val){
    //     this.isShow = false
    //   }else{
    //     this.isShow = true
    //   }
    //   console.log("isCollapse: "+val, oldVal);
    // },

    screenWidth:{
      immediate: true,
      handler:function(newVal){
        if (!this.isMobile()) {
          if (newVal < 767) {
            this.isCollapse = true
            // this.$refs.avatarRef.style.display = 'none'
            if (this.isCollapse) {
              this.asideWidth = '64px'
            }else {
              this.asideWidth = '240px'
            }
          }else{
            this.isCollapse = false
            // this.$refs.avatarRef.style.display = 'block'
            if (this.isCollapse) {
              this.asideWidth = '64px'
            }else {
              this.asideWidth = '240px'
            }
          }
        }
      }
    }
  },
  created(){
    //console.log(this.$store.state.shareMsg);
    // if(!this.$store.state.shareMsg){
    //   return this.$router.push("/developer/login");
    // }
    
    if (this.isMobile()) {
      console.log("移动端");
      this.isCollapse = true
      if (this.isCollapse) {
        this.asideWidth = '0px'
      }else {
        this.asideWidth = '240px'
      }
    } else {
      console.log("pc端");
      this.isCollapse = false
      if (this.isCollapse) {
        this.asideWidth = '64px'
      }else {
        this.asideWidth = '240px'
      }
    }
    this.$nextTick(()=>{
      console.log("----this.$refs.emailwidh.offsetWidth:",this.$refs.emailwidh.offsetWidth);
      this.dropdownWidth = this.$refs.emailwidh.offsetWidth
      if (document.body.clientWidth < 700){
        console.log(document.body.clientWidth);
        this.$refs.avatarRef.style.display = 'none'
      }
    })
    this.role = window.sessionStorage.getItem('role')
    // if(this.role == 'developer'){
      this.title = "七C云 ∙ 开发端"
    // }else if(this.role == 'agent'){
    //   this.title = "七C云 ∙ 代理端"
    // }
    this.getMenuList(this.role)
    this.path = window.sessionStorage.getItem('path')
    this.email = window.sessionStorage.getItem('email')
  },
  mounted(){
    // this.$nextTick(()=>{
    //   if (document.body.clientWidth < 700){
    //     console.log(document.body.clientWidth);
    //     this.$refs.avatarRef.style.display = 'none'
    //     this.isCollapse = true
    //     if (this.isCollapse) {
    //       this.asideWidth = '64px'
    //     }else {
    //       this.asideWidth = '240px'
    //     }
    //   }
    // })
    this.$bus.$on('itemclick',(val)=>{
      //console.log('val=',val.username);
      window.sessionStorage.setItem('username', val.username)
      this.$router.push("/userlog");
      this.path = 'userlog'
    })

    const that = this
    window.onresize = ()=>{
      return(()=>{
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    logout() {
      window.sessionStorage.clear();
      window.localStorage.setItem('token', '')
      // if(this.role == 'developer'){
        this.$router.push("/login");
      // }else if(this.role == 'agent'){
      //   this.$router.push("/login");
      // }
      this.$message.success("退出登录成功");
    },
    async getMenuList(role){
      let result
      // if(role == 'developer'){
      //   console.log('developer');
        result = await this.$http.get('developer/menus')
      // }else if(role == 'agent'){
      //   //console.log('agent');
      //   result = await this.$http.get('agent/menus')
      // }
      console.log("getMenuList",result);
      if(result.data.meta.status === 403){
        //this.$router.push("/developer/login")
        window.sessionStorage.clear();
        window.localStorage.setItem('token', '')
        this.$router.push("/login");
        return this.$message.error(result.meta.msg)
      }else if(result.data.meta.status !== 200){
        return this.$message.error(result.meta.msg)
      }
      this.menuList = result.data.data
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // localStorage.setItem('isiphone',flag)
      //console.log(flag)
      return flag;
    },
    foldCollapse(){
      console.log("点击this.isCollapse:",this.isCollapse);
      this.isShow = this.isCollapse
      if (this.isMobile()) {
        console.log("移动端");
        this.isCollapse = !this.isCollapse
        if (this.isCollapse) {
          this.asideWidth = '0px'
        }else {
          this.asideWidth = '240px'
        }

        console.log("----this.$route.path:",this.$route.path);
        if (this.$route.path == "/datascreen") {
          console.log("发射折叠事件");
          this.$bus.$emit("yidongreloadso", this.isCollapse) 
        }
      } else {
        console.log("pc端");
        this.isCollapse = !this.isCollapse
        if (this.isCollapse) {
          this.asideWidth = '64px'
        }else {
          this.asideWidth = '240px'
        }
        console.log("----this.$route.path:",this.$route.path);
        if (this.$route.path == "/datascreen") {
          console.log("发射折叠事件");
          this.$bus.$emit("pcreloadso", this.isCollapse) 
        }
      }
    },
    onCopyLink(e) {
      this.$message.success('邀请注册链接已复制到剪贴板!')
    },
    saveNavState(index){
      //console.log(index);
      if(!index){
        this.path = window.sessionStorage.getItem('path')
      }else{
        window.sessionStorage.setItem('path', index)
        this.path = index
      }
    },
  },
};
</script>

<style lang="less" scoped>

.el-header {
  background-color: #fff;
  color: #333;
  height: 48px !important;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 10px;
  box-sizing: border-box;
  .el-button {
    // margin: 0 10px 0 0;
    margin-right: 10px;
    margin-top:-2px;
    padding: 7px 8px;
    height: 30px;
    i{
      font-size: 14px;
      margin: 0 10px 0 0;
    }
  }

  .head-right{
    display: flex;
    flex-wrap: nowrap;
  }
  .el-dropdown{
    margin-top: 6px;
  }
  i{
    font-size: 24px;
    margin-top: 2px;
  }
}

.el-aside {
  background-color: #00264a;
  color: #333;
  text-align: center;
  line-height: 200px;
  box-shadow: 2px 0 6px rgba(0,21,41,.35);
  z-index: 1;
  .el-menu {
    height: 100%;
    text-align: left;
    border: none;
    overflow: hidden;
  }
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  // text-align: center;
  // line-height: 160px;
  padding: 0 0 20px 0;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.el-container {
  height: 100%;
}

.logo {
  height: 64px;
  padding: 0 20px;
  line-height: 64px;
  h1{
    font-size: 20px;
    color: #fff;
    display: inline;
    height: 50px;
    margin-left: 16px;
  }
}
a{
  color:#fff;
  text-decoration: none;
}
.el-popper /deep/ .popper__arrow {
  border-bottom-color: #1EBEF4 !important;
  left: 50% !important;
  visibility: hidden;
}
.header-new-drop li {
	width: 200px;
  color: red;
}


@media screen and (max-width:479px) {
  .el-header{
    .head-right{
      .el-dropdown{
        font-size: 12px;
      }
      
      .el-button{
        span{
          font-size: 12px;
        }
      }
    }
  }
  .el-dropdown-menu--medium .el-dropdown-menu__item{
    font-size: 12px !important;
    padding: 0 10px;
    text-align: center;
  }
}
</style>

